module.exports = __webpack_public_path__ + "img/home_bg_13.9ba79415.webp";